import Vue from 'vue'
import App from './App'
import router from './router'
import 'jquery'
import 'jquery.nicescroll'
/*
   引入css
*/

import "./assets/css/reset.css"
import getData from './components/getData/getData'

Vue.prototype.$event = new Vue()
/* 
   引入js
*/

//import "./assets/js/default.js"
Vue.config.productionTip = false

//减法
Vue.prototype.$accSub = function(arg1, arg2){
   var r1, r2, m, n;
   try {
       r1 = arg1.toString().split(".")[1].length;
   }
   catch (e) {
       r1 = 0;
   }
   try {
       r2 = arg2.toString().split(".")[1].length;
   }
   catch (e) {
       r2 = 0;
   }
   m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
   n = (r1 >= r2) ? r1 : r2;
   return ((arg1 * m - arg2 * m) / m).toFixed(n);
 }

 Vue.prototype.$accDiv = function(arg1, arg2){
   var t1 = 0, t2 = 0, r1, r2;
   try {
       t1 = arg1.toString().split(".")[1].length;
   }
   catch (e) {
   }
   try {
       t2 = arg2.toString().split(".")[1].length;
   }
   catch (e) {
   }
       r1 = Number(arg1.toString().replace(".", ""));
       r2 = Number(arg2.toString().replace(".", ""));
       return (r1 / r2) * Math.pow(10, t2 - t1);
 }

Vue.prototype.$loading_show = function(){
   $("#mymask").remove();
   $("#myLayerImg").remove();
   $("body").append("<div class='myLayerLoading' id='mymask'></div>");
   $("body").append("<div class='myLayerImg' id='myLayerImg'></div>");
   $("#mymask").show();
   $("#myLayerImg").show();
}
Vue.prototype.$loading_hide = function(){
   $("#myLayerImg").remove();
   $("#mymask").remove();
}

Vue.prototype.$BGM = function(){
   let isPlayer = sessionStorage.getItem('Voice')
   if(isPlayer == 1){
      document.getElementById('bgm').play()
   }
}
router.beforeEach(async function(to, from, next){
   var paramsKeys = Object.keys(to.query)
   for(let i of paramsKeys){
      if(to.query[i]){
         console.log(i)
         sessionStorage.setItem(i, to.query[i])
      }
   }

   let result = await getData.customAxios("sysInfo")
   let isSearch,status
   if(result.code == 0 && result.msg == "success"){
      console.log(result)
      sessionStorage.setItem('title', result.data.sysTitle)
      sessionStorage.setItem('noticeTitle', result.data.noticeTitle)
      sessionStorage.setItem('noticeContent', result.data.noticeContent)
      isSearch = result.data.isSearch
      status = result.data.status
   }

   if(status == 0){
      if(to.path !== '/' && to.path !== '/404'){
         next('/404')
         return
      }
   }
   if(to.path == '/404'){
      if(status != 0){
         next('/')
         return
      }
   }

   let token = sessionStorage.getItem('token')
   if((token == "" || !token) && status == 1){
      if(isSearch == 1){
         if(to.path !== '/'){
         next('/')
         return
         }
      }else{
         if(to.path == '/'){
         next('/index')
         return
         }
      }
   }else {
      if(to.path == '/'){
         next('/index')
         return
      }
   }
   
   next()
})
/* eslint-disable no-new */
new Vue({
   el: '#app',
   router,
   components: { App },
   template: '<App/>'
})
